/**
 Created by lilei on 2017/10/17. 采编编辑页头部组件
 description: 采编中心编辑页头部组件 左侧及中部

**/
'use strict';
angular.module('editHeaderModule', []).directive('editHeader', [
    '$timeout',
    '$location',
    '$stateParams',
    function($timeout, $location, $stateParams) {
        return {
            restrict: 'E',
            replace: false,
            templateUrl: './editingCenter/directive/editHeader/editHeader.html',
            scope: {
                switchMain: '=',
                thisForm: '=',
                hideInfo: '@', // 不显示的模块，传值时多个模块用逗号隔开
            },
            link: function($scope, iElement, attrs) {
                $scope.locationUrl = $location
                    .absUrl()
                    .split('?')[0]
                    .split('#/')[1];
                $scope.status = {
                    switch: 'manuscriptInfo', // 默认选中稿件信息
                    leftTitle: {
                        fusionnews: '新闻',
                        iwonews: '新闻',
                        websitenews: '新闻',
                        appnews: '新闻',
                        baijiahaonews: '新闻',
                        toutiaohaonews: '新闻',
                        qiehaonews: '新闻',
                        fusionatlas: '图集',
                        iwoatlas: '图集',
                        websiteatlas: '图集',
                        appatlas: '图集',
                        baijiahaoatlas: '图集',
                        qiehaoatlas: '图集',
                        fusionlinkdoc: '链接',
                        appwebsite: '链接',
                        websitelinkdoc: '链接',
                        iwolinkdoc: '链接',
                        websitesubject: '专题',
                        appsubject: '专题',
                        fusionactivity: '活动',
                        appactivity: '活动',
                        fusiontopic: '话题',
                        apptopic: '话题',
                        fusionvideo: '视频',
                        appvideo: '视频',
                        qiehaovideo: '视频',
                        toutiaohaovideo: '视频',
                        fusionlive: '直播',
                        applive: '直播',
                        newspaperpic: '图集',
                        newspapertext: '新闻',
                        reportsummarynews: '新闻',
                        wxeditpage: '新闻',
                        iwobroadcasttvmanuscript:
                            angular.isDefined($stateParams.isfromplannedorder) && $stateParams.isfromplannedorder == 'true'
                                ? '广电文稿 - 新增空白条目'
                                : '广电文稿',
                        televisionmanuscript: '广电文稿',
                        broadcastmanuscript: '广电文稿',
                        weiboedit: '微博',
                        websitevideo: '视频',
                        baijiahaovideo: '视频',
                        trillnews: '视频',
                        appaudio: '音频',
                        operationalActivity: '运营活动',
                        advertisement: '广告',
                        weiboheadlinesedit: '头条文章',
                        kuaishoudraft: '视频',
                    },
                    manuscript: false,
                    attrInfo: false,
                };
                $scope.$watch('thisForm', function(newV, oldV) {
                    if (!newV) {
                        return;
                    }
                    // 接收页面方法
                    var i = 0,
                        errorLen = newV.length,
                        manuscriptError = 0,
                        attrInfoError = 0;
                    while (i < errorLen) {
                        // 判断errorname的位置是属于稿件信息还是属性信息
                        if (angular.element('[name=' + newV[i] + ']').parents('.body_manuscript_content').length > 0) {
                            manuscriptError++;
                        }
                        if (angular.element('[name=' + newV[i] + ']').parents('.attrInfo').length > 0) {
                            attrInfoError++;
                        }
                        i++;
                    }
                    $scope.status.manuscript = manuscriptError > 0;
                    $scope.status.attrInfo = attrInfoError > 0;
                });

                $scope.$watch('switchMain', function() {
                    $scope.status.switch = $scope.switchMain;
                });

                $scope.switch = function(type) {
                    $scope.status.switch = type;
                    $scope.switchMain = $scope.status.switch;
                    document.body.scrollTop = document.documentElement.scrollTop = 0; // 切换头部的时候页面滚动到顶部
                    // $(document).scrollTop(0);
                };
            },
        };
    },
]);
